import { HttpInterceptorFn } from '@angular/common/http';

export const timezoneOffsetInterceptor: HttpInterceptorFn = (req, next) => {
  const timezone = new Date().getTimezoneOffset();

  const clonedRequest = req.clone({
    headers: req.headers.set('X-Timezone-Offset', `${timezone}`),
  });

  return next(clonedRequest);
};
